import ipRegex from 'ip-regex';

export function mapStringToDNSHostOrOriginal(host: string): string {
  if (!host.length) {
    return '';
  }
  if (ipRegex.v6({ exact: true }).test(host)) {
    return `[${host}]`;
  }
  return host;
}

// RFC 1035 wire-format limits. The name limit includes the trailing dot.
const MAX_DNS_NAME_LENGTH = 254;
const MAX_DNS_LABEL_LENGTH = 63;

export const DNS_NAME_EMPTY_ERR = 'All entries must be non-empty DNS names';
export const DNS_NAME_LENGTH_ERR = 'All entries must be 253 characters or fewer';
export const DNS_NAME_EMPTY_LABEL_ERR = 'All entries must not contain empty labels';
export const DNS_LABEL_LENGTH_ERR = 'All labels must be 63 characters or fewer';
export const DNS_LABEL_CHARACTER_ERR = 'All labels must contain only letters, digits, hyphens, and underscores';
export const DNS_LABEL_HYPHEN_ERR = 'Labels must not begin or end with a hyphen';

const DNS_LABEL_REGEX = /^[a-zA-Z0-9_-]+$/;

/**
 * Mirrors the validation the api (and dnclient) apply to `definednet.dns` domains: dot-separated
 * labels of letters, digits, hyphens, and underscores (underscores appear in real-world names like
 * `_domainkey`), no leading or trailing hyphen in a label, and RFC 1035 length limits. Mixed case
 * and a trailing dot are accepted; dnclient normalizes both.
 *
 * Returns an error message, or `null` when the name is acceptable.
 */
export function validateDNSName(name: string): string | null {
  if (!name || name === '.') {
    return DNS_NAME_EMPTY_ERR;
  }

  const trimmed = name.endsWith('.') ? name.slice(0, -1) : name;
  if (trimmed.length + 1 > MAX_DNS_NAME_LENGTH) {
    return DNS_NAME_LENGTH_ERR;
  }

  for (const label of trimmed.split('.')) {
    if (!label) {
      return DNS_NAME_EMPTY_LABEL_ERR;
    }
    if (label.length > MAX_DNS_LABEL_LENGTH) {
      return DNS_LABEL_LENGTH_ERR;
    }
    if (!DNS_LABEL_REGEX.test(label)) {
      return DNS_LABEL_CHARACTER_ERR;
    }
    if (label.startsWith('-') || label.endsWith('-')) {
      return DNS_LABEL_HYPHEN_ERR;
    }
  }

  return null;
}
